import React, {Component} from 'react';
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';
import {EditorPanel, EditorColumn} from '../editor-components';
import {ImageUploader, VideoUploader} from '../uploaders';
import BuilderList from './builder-list';
import ExhibitorSelect from './exhibitor-select';
import './booth-metadata.css';

/** @class BoothMetadata
 * A component for editing a booth's metadata properties
 * (name, published status, and booth icon)
 */
export default class BoothMetadata extends Component {
  /** @constructor
    * Constructs a new instance of BoothMetadata
    */
  constructor(props) {
    super(props);
    this.state = props.metadata;
    this.dataURL = props.dataURL + '/metadata';
    this.handleStatusChange = this.handleStatusChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
  }
  /** @method componentWillReceiveProps
    * Assigns new incoming booth metadata props to state
    * @prop {object} newProps - the new booth state
    */
  componentWillReceiveProps(newProps) {
    this.setState(newProps.metadata);
  }
  /** @function handleStatusChange
    * Handles updates to the status select,
    * limiting options to user-appropriate choices
    * @param {ChangeEvent} - the event that triggered
    * this handler
    */
  handleStatusChange(event) {
    const value = event.target.value;
    const name = 'status';
    if(value === "Approved") {
      // Limit the setting of approval status to admins and expo editors
      const uid = firebase.auth().currentUser.uid;
      firebase.database().ref(`/users/${uid}/role`).once('value', snapshot => {
        const role = snapshot.val();
        if(role === 'Expo Editor' || role === 'Admin') {
          this.setState({
            [name]: value
          }, () => {
            var updates = {}
            updates[`${this.dataURL}/status`] = "Approved";
            Object.keys(this.props.halls || {})
            .forEach(hallID => {
              updates[`${this.props.hallURL}/${hallID}/booths/${this.props.boothID}/published`] = true;
            });
            firebase.database().ref().update(updates);
          });
        } else {
          window.alert("Only Expo Editors or Admins can set a booth to approved status.");
        }
      });
    } else {
      this.setState({
        [name]: value
      }, () => {
        var updates = {}
        updates[`${this.dataURL}/status`] = value;
        Object.keys(this.props.halls || {})
        .forEach(hallID => {
          updates[`${this.props.hallURL}/${hallID}/booths/${this.props.boothID}/published`] = null;
        });
        firebase.database().ref().update(updates);
      });
    }
  }
  /** @function handleChange
    * Handles updates to input fields by updating the
    * component's state
    * @param {ChangeEvent} - the event that triggered
    * this handler
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleBlur
    * Saves changes to the component's state to the
    * firebase entry.
    * @param {ChangeEvent} event - the event that
    * triggered this handler
    */
  handleBlur() {
    firebase.database().ref(`${this.dataURL}`).set(this.state);
  }
  /** @function handleImageUpload
    * Handles updates to images by updating the
    * component's state
    * @param {String} name - the name of the image property
    * @param {Url} url - the url for the new image
    */
  handleImageUpload(name, url) {
    var booth = this.state;
    booth[name] = url;
    this.setState(booth, () => {
      this.handleBlur();
      if(name === "icon" && this.props.halls){
        var updates = {};
        Object.keys(this.props.halls).forEach(hallID => {
          updates[`${this.props.hallURL}/${hallID}/booths/${this.props.boothID}/image`] = url;
        });
        firebase.database().ref().update(updates);
      }
    });
  }
  /** @function render
    * Renders the component
    */
  render() {
    return (
      <EditorPanel>
        <EditorColumn>
          <div className="input-group">
            <label htmlFor="name">Name</label><br/>
            <input type="text" name="name"
              value={this.state.name}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="status">
              Status
            </label>
            <select name="status"
              value={this.state.status}
              onChange={this.handleStatusChange}>
                <option value="Unassigned">Unassigned</option>
                <option value="Assigned">Assigned</option>
                <option value="In Progress">In Progress</option>
                <option value="Ready for Review">Ready for Review</option>
                <option value="Approved">Approved</option>
            </select>
          </div>
          <ExhibitorSelect
            value={this.props.exhibitorID}
            dataURL={this.props.dataURL}
            name={this.state.name}
            status={this.state.status}
            />
          <BuilderList builders={this.props.builders} dataURL={this.props.dataURL} />
          <div className="input-group">
            <label>Appears in Hall(s)</label>
            <ul>
              {Object.keys(this.props.halls || {}).map(key => (
                <li key={key}>{this.props.halls[key]}</li>
              ))}
            </ul>
          </div>
          <div className="input-group">
            <VideoUploader
              name="Welcome Video"
              value={this.state.welcomeVideo}
              dataURL={this.dataURL + '/welcomeVideo'}
              onUpload={(url)=>this.handleImageUpload('welcomeVideo', url)}
              />
          </div>
        </EditorColumn>
        <EditorColumn>
          <div className="input-group metadata-icon">
            <ImageUploader
              name="Booth Icon"
              value={this.state.icon}
              dataURL={this.dataURL + '/icon'}
              onUpload={(url)=>this.handleImageUpload('icon', url)}
              />
          </div>
          <div className="input-group">
            <ImageUploader
              name="Booth Interior"
              value={this.state.interior}
              dataURL={this.dataURL + '/interior'}
              onUpload={(url)=>this.handleImageUpload('interior', url)}
              />
          </div>
        </EditorColumn>
      </EditorPanel>
    );
  }
}



// WEBPACK FOOTER //
// ./src/booth-editor/booth-metadata.js